'use client';

import { EventBanner } from './event-banner';
import { MilestoneRewards } from './milestone-rewards';
import { GlobalEventLeaderboard } from './global-event-leaderboard';
import { useGetUserGlobalEvents } from '@wwe-portal/web/providers/queries/rbe';
import { useTranslations } from 'next-intl';
import { EventItemLayout, EventListLayout } from './event-layout';
import { RBE_SECTIONS } from '@wwe-portal/web/utils/constants/rbe';
import { EventStatisticBadge } from './event-badge';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';

export const GlobalEventSection = () => {
  const t = useTranslations();
  const isAuthenticated = useIsAuthenticated();
  const { globalEvents, userGlobalEvents, userProgressMap } =
    useGetUserGlobalEvents();

  return (
    <EventListLayout id={RBE_SECTIONS.GLOBAL_EVENT_SECTION}>
      {globalEvents?.map((event) => {
        const currentProgress = userProgressMap.get(event.portalEventId);
        return (
          <EventItemLayout
            key={event.portalEventId}
            id={String(event.portalEventId)}
            banner={
              <EventBanner
                eventData={event}
                userProgress={currentProgress}
                eventType={t('rbe.type.global')}
                badge={
                  <div className="flex items-center justify-end gap-2.5">
                    {userGlobalEvents && isAuthenticated && (
                      <EventStatisticBadge
                        point={currentProgress?.userPoint ?? 0}
                        label={t('your_event_point')}
                      />
                    )}
                    <EventStatisticBadge
                      point={currentProgress?.participantsCount}
                      label={t('participants')}
                      variant="participants"
                    />
                  </div>
                }
              />
            }
            milestones={
              <MilestoneRewards
                eventData={event}
                userProgress={userProgressMap.get(event.portalEventId)}
              />
            }
            leaderboard={<GlobalEventLeaderboard event={event} />}
          />
        );
      })}
    </EventListLayout>
  );
};
